import { can } from '../core/access';
import { tabIcons } from '../ui/icons';
import { t } from '../ui/lang';
import { renderServersTab } from './servers-tab';
import { renderTelegramTab } from './telegram-tab';
import { renderCodeTab } from './code-tab';
import { renderRunnerCodeTab } from './runner-code-tab';
import { renderClickerAppsTab } from './clicker-apps-tab';
/**
 * The Clicker page (`#!/clicker`): the superadmin-only Servers / Telegram / Code /
 * Runner / Apps tab strip. Each tab lives in its own module ({servers,telegram,code}-tab.ts);
 * this view only wires the strip and dispatches to those renderers.
 */
export async function renderClickerSettings() {
    const content = document.getElementById('content');
    const pageTitle = document.getElementById('page-title');
    pageTitle.textContent = t('clickertab.clicker');
    const showApps = can('clicker.apps');
    const appsTabBtn = showApps ? `<button class="settings-tab" data-tab="apps">${tabIcons.apps}${t('clickertab.apps')}</button>` : '';
    const appsPanel = showApps ? '<div class="settings-panel" data-panel="apps" style="display:none"></div>' : '';
    content.innerHTML = `
        <div class="settings-tabs" role="tablist">
            <button class="settings-tab active" data-tab="servers">${tabIcons.servers}${t('clickertab.servers')}</button>
            <button class="settings-tab" data-tab="telegram">${tabIcons.telegram}${t('clickertab.telegram')}</button>
            <button class="settings-tab" data-tab="code">${tabIcons.code}${t('clickertab.code')}</button>
            <button class="settings-tab" data-tab="runner">${tabIcons.runner}${t('clickertab.clicker_runner')}</button>
            ${appsTabBtn}
        </div>
        <div class="settings-panel" data-panel="servers"></div>
        <div class="settings-panel" data-panel="telegram" style="display:none"></div>
        <div class="settings-panel" data-panel="code" style="display:none"></div>
        <div class="settings-panel" data-panel="runner" style="display:none"></div>
        ${appsPanel}
    `;
    const tabs = Array.from(content.querySelectorAll('.settings-tab'));
    const panels = Array.from(content.querySelectorAll('.settings-panel'));
    const showTab = (key) => {
        tabs.forEach((t) => t.classList.toggle('active', t.dataset['tab'] === key));
        panels.forEach((p) => { p.style.display = p.dataset['panel'] === key ? '' : 'none'; });
    };
    tabs.forEach((t) => t.addEventListener('click', () => showTab(t.dataset['tab'])));
    const serversPanel = content.querySelector('[data-panel="servers"]');
    const telegramPanel = content.querySelector('[data-panel="telegram"]');
    const codePanel = content.querySelector('[data-panel="code"]');
    const runnerPanel = content.querySelector('[data-panel="runner"]');
    void renderServersTab(serversPanel);
    void renderTelegramTab(telegramPanel);
    void renderCodeTab(codePanel);
    void renderRunnerCodeTab(runnerPanel);
    const appsPanelEl = content.querySelector('[data-panel="apps"]');
    if (appsPanelEl)
        void renderClickerAppsTab(appsPanelEl);
}
